import React from 'react';
import { Box, List, ListItemButton, Stack } from '@mui/material';
import CurrencyValue from '../../../../components/material-ui/CurrencyValue';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';

export default function BalanceAside({
  currencies,
  selectCurrency,
  setSelectCurrency,
  commonBalance
}) {
  const { isMobile } = useBootstrapSize();

  return (
    <Stack gap={2} minWidth={isMobile ? 100 : 180} width={180}>
      {/* <Typography variant="h6">{t('Total balance')}</Typography> */}
      <Stack>
        <List disablePadding>
          {currencies.map((currency) => {
            const openBalance = commonBalance[currency]?.main || 0;
            const depositBalance = commonBalance[currency]?.deposit || 0;
            const mainBalance = openBalance + depositBalance;

            return (
              <ListItemButton
                key={currency}
                selected={currency == selectCurrency}
                sx={{ borderRadius: 1 }}
                onClick={() => setSelectCurrency(currency)}>
                <Box component={'span'}>
                  <CurrencyValue
                    value={mainBalance}
                    currency={currency}
                    fontSize={14}
                    defaultValue="0"
                  />
                </Box>
              </ListItemButton>
            );
          })}
        </List>
      </Stack>
    </Stack>
  );
}
